<template>
  <div id='bd-super'>
    超级管理员
  </div>
</template>

<script>
export default {
  name: 'bd-super'

}
</script>

<style scoped>

</style>
